<template>
    <Dialog size="small">
        <template v-slot:title>
            カスタム項目名の編集
        </template>

        <template v-slot:body>
            <div class="custom-field-form-wrapper">
                <el-form label-width="170px" class="dialog-form-item" :model="form" :rules="rules" ref="form">
                    <el-form-item prop="name">
                        <span slot="label">カスタム項目名</span>
                        <el-input v-model="form.name" ></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </template>

        <template v-slot:button>
            <el-button class="dialog-cancel-button" @click="handleCancelClick" v-t="'message.button_cancel'"></el-button>
            <el-button class="dialog-ok-button" :disabled="disableSave" @click="handleSaveClick" v-t="'message.button_save'"></el-button>
        </template>
    </Dialog>

</template>

<script>
import server from "@/components/ServerApi.js";
import constants from "@/components/constants.js";
import commonUtil from '@/components/commonutil.js';
import Dialog from '@/components/pc/common/Dialog.vue';
import commonValidate from './common-validate.js';

export default {
    components: {
        Dialog
    },

    props: [
        `customName`,
    ],

    data() {
        var validatePass = (rule, value, callback) => {
            let validateResult = commonValidate.validateItem(this.$i18n, "reqDisplayName", value)
            if (validateResult.valid) {
                callback()
            } else {
                callback(new Error(validateResult.message))
            }
        };
        return {
            // Element UI の el-tree 用 props
            treeProps: {
                label: 'displayName'
            },

            selectedModel: null,
            selectedSettingId: null,
            selectedSettingName: null,

            modelList: [],
            settingsToShow: [],
            form: {
                name: null
            },
            nameValid: true,
            rules: {
                name: [
                    { validator: validatePass, trigger: 'blur' }
                ]
            }
        }
    },

    computed: {
        disableSave() {
            if (this.form.name === null || this.form.name == "") {
                return true;
            }
            return !this.nameValid;
        },
    },

    watch: {
        'form.name'() {
            // 入力のたびに検証して保存ボタンの活性/非活性を切り替える
            this.$nextTick(() => {
                if (this.$refs.form && this.$refs.form.validateField) {
                    this.$refs.form.validateField('name', (errorMessage) => {
                        this.nameValid = !errorMessage;
                    })
                }
            })
        },
    },

    created() {
        this.form.name = this.customName;
        this.$nextTick(() => {
            if (this.$refs.form && this.$refs.form.validateField) {
                this.$refs.form.validateField('name', (errorMessage) => {
                    this.nameValid = !errorMessage;
                })
            }
        })
    },

    methods: {
        closeDialog() {
            this.$emit('cancel')
        },

        initialize() {
            this.selectedModel = null;
            this.selectedSettingId = null;
            this.selectedSettingName = null;
            this.settingsToShow = [];
        },

        onModelSelect(model) {
            this.selectedModel = model;
            this.fetchSettingList();
        },

        onNodeClick(nodeData) {
            this.selectedSettingId = nodeData.id;
            this.selectedSettingName = nodeData.displayName;
        },

        async fetchModelList() {
            let response
            try {
                response = await server.post('/getipradiomodellist')
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchModelList", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.modelList = response.data.modelList.map(model => ({value:model, label:model}));
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "fetchModelList", response.data.status);
                    break;
            }
        },

        async fetchSettingList() {
            let response
            try {
                response = await server.post('/getipradiosettinglist', {model: this.selectedModel})
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchSettingList", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.settingsToShow = response.data.settings;
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "fetchSettings", response.data.status);
                    break;
            }
        },

        handleSaveClick() {
            // 念のため送信時にも全体バリデーション
            this.$refs.form.validate((valid) => {
                this.nameValid = valid;
                if (!valid) {
                    return;
                }
                this.$emit('save', this.form.name)
                this.closeDialog()
            })
        },

        handleCancelClick() {
            this.closeDialog()
        }
    }
}
</script>

<style scoped>

.custom-field-form-wrapper {
    height: 90%;
    margin: 4px 80px;
    display: flex;
    justify-content: center;
    align-items: center;
}


:deep(.settings-tree .el-tree-node__expand-icon) {
    display: none !important;
}

</style>
